const ROUTES = {
    SIGNEE: 'signee',
    SAMPLES: 'samples',
    SIGNATURE: 'signature',
    AOC: 'aoc',
    INQUIRIES: 'inquiries',
    SHARE_LINK: 'share-link',
    SHARE_LINK_SIGNEE: 'share-link-signee',
    SHARE_LINK_INQUIRIES: 'share-link-inquiries',
    UNSUPPORTED: 'unsupported',
    EXPIRED: 'expired',
    CANCELED: 'canceled',
    COMPLETED: 'completed',
    LINK_ERROR: 'link-error',
    SAMPLE_OPT_IN: 'sample-opt-in'
};

const SIGNATURE_AREA = {
    HEIGHT: 159,
    WIDTH: 516
};

const LARGE_SCREEN_SIZE = {
    HEIGHT: 664,
    WIDTH: 500
};

const SMALL_SCREEN_THRESHOLD = {
    HEIGHT: 300
};

const LAYOUT_BREAKPOINTS = {
    MOBILE: 430 // the largest viewport side for iPhone
};

const CONSTRAINTS = {
    STORAGE_LIMIT: 32000,
    MIN_POINTS: 10,
    // there needs to be a minimum of 10 points to form 3 distinct Bezier curves (distinct changes in strokes) assuming the user does not lose contact with the canvas element
    // the library also uses cubic Bezier curves to interpolate lines between points, which is why 4 control points are used for each curvature
    // P0, P1, P2, P3 forms the first Bezier curve B0
    // P3, P4, P5, P6 forms the second Bezier curve B1
    // P6, P7, P8, P9 forms the third Bezier curve B2
    MIN_LENGTH: 100
};

const MUTATION_NAMESPACE = {
    AOC: 'aoc',
    MESSAGE: 'message'
};

const MUTATION_NAME = {
    SET_BANNER_URL: 'setBannerUrl',
    SET_SIGNEE: 'setSignee',
    SET_DETAILED_PRODUCTS: 'setDetailedProducts',
    SET_ADDRESS: 'setAddress',
    SET_SAMPLES: 'setSamples',
    SET_LICENSE: 'setLicense',
    SET_DEA: 'setDea',
    SET_SHIP_TO_LICENSE: 'setShipToLicense',
    SET_SHIP_TO_DEA: 'setShipToDea',
    SET_SHIP_TO_ADDRESS: 'setShipToAddress',
    SET_SHIP_TO_LOCATION: 'setShipToLocation',
    SET_DISCLAIMER: 'setDisclaimer',
    SET_MESSAGE_INVALID_SIGNATURE: 'setMessageInvalidSignature',
    SET_SIGNIN_ID: 'setSigninId',
    SET_PREFERRED_LANGUAGE: 'setPreferredLanguage',
    SET_SIGNATURE: 'setSignature',
    SET_LOADED: 'setLoaded',
    SET_UUID: 'setUuid',
    SET_INQUIRIES: 'setInquiries',
    SET_ROUTE: 'setRoute',
    SET_CHANNEL_ID: 'setChannelId',
    SET_SIGNATURE_TYPE: 'setSignatureType',
    SET_HOST_NAME: 'setHostName',
    SET_CONSENT: 'setConsent',
    SET_EXPIRE_TIMEOUT_ID: 'setExpireTimeoutId',
    SET_REQUEST_FINISHED: 'setRequestFinished',
    SET_LOCATION: 'setLocation',
    SET_SHIP_DATE: 'setShipDate',
    SET_SHIP_CDS: 'setShipCds',
    SET_SHIP_STATE_DISTRIBUTOR: 'setShipStateDistributor',
    SET_DELIVERY_DATE: 'setDeliveryDate',
    SET_ORDER_ID: 'setOrderId',
    SET_RECEIVED_BY: 'setReceivedBy',
    SET_RECEIVED_BY_FIRST_NAME: 'setReceivedByFirstName',
    SET_RECEIVED_BY_MIDDLE_NAME: 'setReceivedByMiddleName',
    SET_RECEIVED_BY_LAST_NAME: 'setReceivedByLastName',
    SET_RECEIVED_TITLE: 'setReceivedTitle',
    SET_ACCOUNT_FIRST_NAME: 'setAccountFirstName',
    SET_ACCOUNT_MIDDLE_NAME: 'setAccountMiddleName',
    SET_ACCOUNT_LAST_NAME: 'setAccountLastName',
    SET_ACCOUNT_CREDENTIALS: 'setAccountCredentials',
    SET_CONTENT_ACKNOWLEDGEMENT_ITEMS: 'setContentAcknowledgementItems',
    SET_VEEVA_MESSAGE: 'setVeevaMessage'
};

const POST_MESSAGES = {
    CLOSE_SIGNATURE: 'closeSignature',
    CLOSE_SIGNATURE_PAGE: 'closeSignaturePage',
    CLOSE_WEB_VIEW: 'closeWebView',
    SAVE_SIGNATURE_ERROR: 'saveSignatureError',
    CLEAR_SIGNATURE: 'clearSignature',
    CONFIRM_CLEAR_SIGNATURE: 'confirmClearSignature',
    CLICK_BACK: 'clickBack',
    FINISH_SIGNATURE: 'finishSignature',
    POST_SIGNATURE: 'postSignature'
};

const EVENT_TYPES = {
    SIGNATURE_REVIEW_GET: 'signature_review_get',
    SIGNATURE_SUBMIT_POST: 'signature_submit_post',
    SIGNATURE_SIZE_LARGE: 'signature_size_large',
    SIGNATURE_PAGE_LOAD: 'signature_page_load',
    SIGNATURE_PAGE_EXIT: 'signature_page_exit',
    ERROR_WEB_SOCKET: 'error_ws',
    CANCEL_SIGNATURE: 'ws_cancel_signature',
    FINISH_SIGNATURE: 'ws_finish_signature',
    SOCKET_CONNECT: 'ws_connect',
    SOCKET_SUBSCRIBE: 'ws_subscribe',
    SOCKET_MESSAGE: 'ws_message',
    SOCKET_DISCONNECT: 'ws_disconnect',
    SOCKET_DEACTIVATE: 'ws_deactivate'
};

const EVENT_MESSAGES = {
    SIGNATURE_PAGE_LOAD: 'HCP` with signinId: {0} rendered signature page',
    SIGNATURE_PAGE_EXIT: 'HCP with signinId: {0} has closed the signature pages',
    SIGNATURE_SIZE_LARGE: 'HCP with signinId: {0} attempted to save a signature exceeding 32kb',
    SAMPLE_REVIEW_GET_SUCCESS: 'HCP with signinId: {0} succeeded sample GET request',
    SAMPLE_REVIEW_GET_FAIL: 'HCP with signinId: {0} failed sample GET request with error status {1} and message {2}',
    INQUIRY_REVIEW_GET_SUCCESS: 'HCP with signinId: {0} succeeded inquiry GET request',
    INQUIRY_REVIEW_GET_FAIL: 'HCP with signinId: {0} failed inquiry GET request with error status {1} and message {2}',
    OPT_IN_GET_SUCCESS: 'HCP with signinId: {0} succeeded opt in GET request',
    OPT_IN_GET_FAIL: 'HCP with signinId: {0} failed opt in GET request with error status {1} and message {2}',
    SOCKET_MESSAGE: 'HCP with channelId: {0} and uuid: {1} recieved message: {2} on endPoint: {3}',
    SOCKET_STOMP_ERROR: 'HCP with channelId: {0} and uuid: {1} recieved Stomp error message: {2}',
    SOCKET_CONNECT_SUCCESS: 'HCP with channelId: {0} and uuid: {1} successfully connected to websocket',
    SOCKET_CONNECT_ERROR: 'HCP with channelId: {0} and uuid: {1} failed to connect to websocket',
    SOCKET_SUBSCRIBE_SUCCESS: 'HCP with channelId: {0} and uuid: {1} successfully subscribed end point: {2}',
    SOCKET_SUBSCRIBE_ERROR: 'HCP with channelId: {0} and uuid: {1} failed to connect to websocket with error: {2}',
    SOCKET_DISCONNECT: 'HCP with channelId: {0} and uuid: {1} disconnected from websocket',
    SOCKET_DEACTIVATE: 'HCP with channelId: {0} and uuid: {1} deactivated stomp client'
};

const LOGGING_CONSTANTS = {
    APP_NAME: 'remote_signatures'
};

const ENGAGE_URLS = {
    BASE: 'https://engage-app-us.veevacrm.com',
    API_V1: '/api/v1',
    API_V2: '/api/v2'
};

const RESPONSE_STATUS = {
    UNAUTHORIZED: 401,
    SIGNATURE_EXISTS: 409
};

const SIGNATURE_STATUS = {
    DECLINED: 'DECLINED',
    SUBMITTED: 'SUBMITTED'
};

const WEBSOCKET_HEADERS = {
    CONNECTION_TYPE: 'SHARE_LINK',
    SUPPORTED_REMOTE_SIGNATURES:'SAMPLE,MEDICAL_INQUIRY,MULTICHANNEL_CONSENT,CONTENT_ACKNOWLEDGEMENT',
    APP_TYPE: 'SIGNATURE_PAGES',
    APP_VERSION: '261.0.200'
};

const WEBSOCKET_END_POINTS = {
    ENGAGE_CHANNEL_END_POINT: '/user/ws-topic/engage-channels',
    SIGNATURE_END_POINT: '/user/ws-topic/signatures'
};

const WEBSOCKET_ERRORS = {
    MISSING_HEADERS: 'MISSING_HEADERS',
    MISSING_CHANNEL: 'MISSING_CHANNEL',
    RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
    CHANNEL_EXPIRED: 'CHANNEL_EXPIRED'
};

const WEBSOCKET_PROPERTIES = {
    RECONNECT_DELAY: 5000,
    HEARTBEAT: 10000,
    TIMEOUT: 10000
};

const WEBSOCKET_STATUS = {
    ACTIVE: 1
};

const WEBSOCKET_MESSAGE = {
    ENGAGE_CHANNEL_DELAY: 1000
};

const MESSAGE_ACTIONS = {
    REQUEST_SIGNATURE: 'REQUEST_SIGNATURE',
    CANCEL_SIGNATURE: 'CANCEL_SIGNATURE',
    FINISH_SIGNATURE: 'FINISH_SIGNATURE',
    CLOSED: 'CLOSED',
    MEDICAL_INQUIRY: 'MEDICAL_INQUIRY',
    SAMPLE: 'SAMPLE',
    MULTICHANNEL_CONSENT: 'MULTICHANNEL_CONSENT',
    DISCONNECT: 'DISCONNECT',
    EXPIRED: 'EXPIRED',
    CONTENT_ACKNOWLEDGEMENT: 'CONTENT_ACKNOWLEDGEMENT'
};

const ENVIRONMENT = {
    INTERNAL: false
};

const EMIT_EVENTS = {
    TAP_SIGNATURE: 'tap-signature',
    CLEAR_SIGNATURE: 'clear-signature',
    CLOSE_ERROR: 'close-error',
    START_SIGNATURE: 'start-signature',
    COMPLETE_SIGNATURE: 'complete-signature',
    CLOSE_SIGNATURE: 'close-signature',
    CANCEL_SIGNATURE: 'cancel-signature',
    CLOSE_CONNECTION_LOST: 'close-connection-lost',
    MOVE_ON: 'move-on',
    CLICK_BACK: 'click-back',
    INFO_CARD_ROW_CELL_EDIT: 'info-card-row-cell-edit',
    TOGGLE_CHANGE: 'toggle-change',
    MODAL_HIDE: 'modal-hide',
    MODAL_CONFIRM: 'modal-confirm',
    MODAL_DECLINE: 'modal-decline'
};

const UNSUPPORTED_BROWSERS = ['WindowsWeChat', 'MSIE', 'UC'];

const COLORS = {
    BUTTON_TEXT_GREY: "#aeaeae",
    CANCEL_BLUE: "#007aff",
    TEXT_WHITE: "#ffffff"
};

const EXPIRE_TIMEOUT = {
    SIGNATURE_SUBMISSION: 15000
};

const SIGNATURE_CONFLICT_ERROR = {
    CANCELLED: 'CANCELLED'
};

const SIGNATURE_TYPES = {
    REMOTE_MEETING: "REMOTE_MEETING",
    ASYNC_SIGNATURE: "ASYNC_SIGNATURE",
    SHARE_LINK: "SHARE_LINK"
};

const BROWSER_NAMES = {
    "FIREFOX": "Firefox",
    "CHROME": "Chrome",
    "SAFARI": "Safari",
    "EDGE": "Edge",
    "EDGE_DESCRIPTION": "Edge v. 83+",
    "VEEVA_ENGAGE": "Veeva Engage"
};

export {
    ROUTES,
    MUTATION_NAMESPACE,
    MUTATION_NAME,
    ENGAGE_URLS,
    POST_MESSAGES,
    CONSTRAINTS,
    SIGNATURE_AREA,
    LARGE_SCREEN_SIZE,
    SMALL_SCREEN_THRESHOLD,
    LAYOUT_BREAKPOINTS,
    EVENT_TYPES,
    EVENT_MESSAGES,
    LOGGING_CONSTANTS,
    SIGNATURE_STATUS,
    WEBSOCKET_HEADERS,
    ENVIRONMENT,
    MESSAGE_ACTIONS,
    EMIT_EVENTS,
    WEBSOCKET_END_POINTS,
    WEBSOCKET_ERRORS,
    RESPONSE_STATUS,
    WEBSOCKET_STATUS,
    WEBSOCKET_MESSAGE,
    WEBSOCKET_PROPERTIES,
    UNSUPPORTED_BROWSERS,
    COLORS,
    EXPIRE_TIMEOUT,
    SIGNATURE_CONFLICT_ERROR,
    SIGNATURE_TYPES,
    BROWSER_NAMES
};
